/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query'

import type {
  CryptoRedemptionOption,
  RedemptionOption,
  RedemptionsRedemptionOptionsGtoWizardListParams,
  SiteTransferRedemptionOption,
  Subscription,
} from '../models'

import redemptionsRedemptionOptionsCryptoListMutator from '../../client'
import redemptionsRedemptionOptionsGtoWizardListMutator from '../../client'
import redemptionsRedemptionOptionsSiteTransferListMutator from '../../client'
import redemptionsSubscribeCreateMutator from '../../client'

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<{ [Q in P]: T[P] }, { -readonly [Q in P]: T[P] }, P>
}[keyof T]

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void
  ? I
  : never
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never

type Writable<T> = Pick<T, WritableKeys<T>>
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object ? NonReadonly<NonNullable<T[P]>> : T[P]
    }
  : DistributeReadOnlyOverUnions<T>

/**
 * API view to list all active crypto redemption options.
 */
export const redemptionsRedemptionOptionsCryptoList = (signal?: AbortSignal) => {
  return redemptionsRedemptionOptionsCryptoListMutator<CryptoRedemptionOption[]>({
    url: `/api/v1/redemptions/redemption-options/crypto/`,
    method: 'GET',
    signal,
  })
}

export const getRedemptionsRedemptionOptionsCryptoListQueryKey = () => {
  return [`/api/v1/redemptions/redemption-options/crypto/`] as const
}

export const getRedemptionsRedemptionOptionsCryptoListQueryOptions = <
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getRedemptionsRedemptionOptionsCryptoListQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>
  > = ({ signal }) => redemptionsRedemptionOptionsCryptoList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RedemptionsRedemptionOptionsCryptoListQueryResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>
>
export type RedemptionsRedemptionOptionsCryptoListQueryError = unknown

export function useRedemptionsRedemptionOptionsCryptoList<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
        TError,
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedemptionsRedemptionOptionsCryptoList<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
        TError,
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedemptionsRedemptionOptionsCryptoList<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
      TError,
      TData
    >
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRedemptionsRedemptionOptionsCryptoList<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
      TError,
      TData
    >
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRedemptionsRedemptionOptionsCryptoListQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getRedemptionsRedemptionOptionsCryptoListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getRedemptionsRedemptionOptionsCryptoListQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>
  > = ({ signal }) => redemptionsRedemptionOptionsCryptoList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RedemptionsRedemptionOptionsCryptoListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>
>
export type RedemptionsRedemptionOptionsCryptoListSuspenseQueryError = unknown

export function useRedemptionsRedemptionOptionsCryptoListSuspense<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedemptionsRedemptionOptionsCryptoListSuspense<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedemptionsRedemptionOptionsCryptoListSuspense<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRedemptionsRedemptionOptionsCryptoListSuspense<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoList>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRedemptionsRedemptionOptionsCryptoListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * API view to list all active GTO Wizard subscription redemption options.
 */
export const redemptionsRedemptionOptionsGtoWizardList = (
  params?: RedemptionsRedemptionOptionsGtoWizardListParams,
  signal?: AbortSignal,
) => {
  return redemptionsRedemptionOptionsGtoWizardListMutator<RedemptionOption[]>({
    url: `/api/v1/redemptions/redemption-options/gto-wizard/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getRedemptionsRedemptionOptionsGtoWizardListQueryKey = (
  params?: RedemptionsRedemptionOptionsGtoWizardListParams,
) => {
  return [
    `/api/v1/redemptions/redemption-options/gto-wizard/`,
    ...(params ? [params] : []),
  ] as const
}

export const getRedemptionsRedemptionOptionsGtoWizardListQueryOptions = <
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
  TError = unknown,
>(
  params?: RedemptionsRedemptionOptionsGtoWizardListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
        TError,
        TData
      >
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getRedemptionsRedemptionOptionsGtoWizardListQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>
  > = ({ signal }) => redemptionsRedemptionOptionsGtoWizardList(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RedemptionsRedemptionOptionsGtoWizardListQueryResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>
>
export type RedemptionsRedemptionOptionsGtoWizardListQueryError = unknown

export function useRedemptionsRedemptionOptionsGtoWizardList<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
  TError = unknown,
>(
  params: undefined | RedemptionsRedemptionOptionsGtoWizardListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
          TError,
          Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>
        >,
        'initialData'
      >
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedemptionsRedemptionOptionsGtoWizardList<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
  TError = unknown,
>(
  params?: RedemptionsRedemptionOptionsGtoWizardListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
          TError,
          Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>
        >,
        'initialData'
      >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedemptionsRedemptionOptionsGtoWizardList<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
  TError = unknown,
>(
  params?: RedemptionsRedemptionOptionsGtoWizardListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
        TError,
        TData
      >
    >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRedemptionsRedemptionOptionsGtoWizardList<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
  TError = unknown,
>(
  params?: RedemptionsRedemptionOptionsGtoWizardListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
        TError,
        TData
      >
    >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRedemptionsRedemptionOptionsGtoWizardListQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getRedemptionsRedemptionOptionsGtoWizardListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
  TError = unknown,
>(
  params?: RedemptionsRedemptionOptionsGtoWizardListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
        TError,
        TData
      >
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getRedemptionsRedemptionOptionsGtoWizardListQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>
  > = ({ signal }) => redemptionsRedemptionOptionsGtoWizardList(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RedemptionsRedemptionOptionsGtoWizardListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>
>
export type RedemptionsRedemptionOptionsGtoWizardListSuspenseQueryError = unknown

export function useRedemptionsRedemptionOptionsGtoWizardListSuspense<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
  TError = unknown,
>(
  params: undefined | RedemptionsRedemptionOptionsGtoWizardListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedemptionsRedemptionOptionsGtoWizardListSuspense<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
  TError = unknown,
>(
  params?: RedemptionsRedemptionOptionsGtoWizardListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedemptionsRedemptionOptionsGtoWizardListSuspense<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
  TError = unknown,
>(
  params?: RedemptionsRedemptionOptionsGtoWizardListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRedemptionsRedemptionOptionsGtoWizardListSuspense<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
  TError = unknown,
>(
  params?: RedemptionsRedemptionOptionsGtoWizardListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRedemptionsRedemptionOptionsGtoWizardListSuspenseQueryOptions(
    params,
    options,
  )

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * API view to list available site transfer redemption options for a user.
 */
export const redemptionsRedemptionOptionsSiteTransferList = (signal?: AbortSignal) => {
  return redemptionsRedemptionOptionsSiteTransferListMutator<SiteTransferRedemptionOption[]>({
    url: `/api/v1/redemptions/redemption-options/site-transfer/`,
    method: 'GET',
    signal,
  })
}

export const getRedemptionsRedemptionOptionsSiteTransferListQueryKey = () => {
  return [`/api/v1/redemptions/redemption-options/site-transfer/`] as const
}

export const getRedemptionsRedemptionOptionsSiteTransferListQueryOptions = <
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getRedemptionsRedemptionOptionsSiteTransferListQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>
  > = ({ signal }) => redemptionsRedemptionOptionsSiteTransferList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RedemptionsRedemptionOptionsSiteTransferListQueryResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>
>
export type RedemptionsRedemptionOptionsSiteTransferListQueryError = unknown

export function useRedemptionsRedemptionOptionsSiteTransferList<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
        TError,
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedemptionsRedemptionOptionsSiteTransferList<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
        TError,
        Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedemptionsRedemptionOptionsSiteTransferList<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
      TError,
      TData
    >
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRedemptionsRedemptionOptionsSiteTransferList<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
      TError,
      TData
    >
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRedemptionsRedemptionOptionsSiteTransferListQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getRedemptionsRedemptionOptionsSiteTransferListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getRedemptionsRedemptionOptionsSiteTransferListQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>
  > = ({ signal }) => redemptionsRedemptionOptionsSiteTransferList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RedemptionsRedemptionOptionsSiteTransferListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>
>
export type RedemptionsRedemptionOptionsSiteTransferListSuspenseQueryError = unknown

export function useRedemptionsRedemptionOptionsSiteTransferListSuspense<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedemptionsRedemptionOptionsSiteTransferListSuspense<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedemptionsRedemptionOptionsSiteTransferListSuspense<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRedemptionsRedemptionOptionsSiteTransferListSuspense<
  TData = Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferList>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRedemptionsRedemptionOptionsSiteTransferListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const redemptionsSubscribeCreate = (
  subscription: NonReadonly<Subscription>,
  signal?: AbortSignal,
) => {
  return redemptionsSubscribeCreateMutator<Subscription>({
    url: `/api/v1/redemptions/subscribe/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: subscription,
    signal,
  })
}

export const getRedemptionsSubscribeCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redemptionsSubscribeCreate>>,
    TError,
    { data: NonReadonly<Subscription> },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof redemptionsSubscribeCreate>>,
  TError,
  { data: NonReadonly<Subscription> },
  TContext
> => {
  const mutationKey = ['redemptionsSubscribeCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof redemptionsSubscribeCreate>>,
    { data: NonReadonly<Subscription> }
  > = (props) => {
    const { data } = props ?? {}

    return redemptionsSubscribeCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type RedemptionsSubscribeCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsSubscribeCreate>>
>
export type RedemptionsSubscribeCreateMutationBody = NonReadonly<Subscription>
export type RedemptionsSubscribeCreateMutationError = unknown

export const useRedemptionsSubscribeCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redemptionsSubscribeCreate>>,
    TError,
    { data: NonReadonly<Subscription> },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof redemptionsSubscribeCreate>>,
  TError,
  { data: NonReadonly<Subscription> },
  TContext
> => {
  const mutationOptions = getRedemptionsSubscribeCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
